import { Dialog } from '@mantine/core';
import { useIdle } from '@mantine/hooks';
import { Text } from '@repo/foundations';
import { useDebounceEffect } from 'ahooks';
import { useCallback } from 'react';
import { useServiceWorkerUpdate } from '../../hooks/useServiceWorkerUpdate';

const DEV_AUTO_UPDATE_INTERVAL = 1_000 * 3; // 3 seconds
const PRD_AUTO_UPDATE_INTERVAL = 1_000 * 60 * 1.25; // 1.25 minute

function ReloadPrompt() {
	const { needRefresh, updateServiceWorker } = useServiceWorkerUpdate();

	const idle = useIdle(
		import.meta.env.DEV ? DEV_AUTO_UPDATE_INTERVAL : PRD_AUTO_UPDATE_INTERVAL
	);

	const update = useCallback(async () => {
		try {
			await updateServiceWorker();
		} catch {
			window.location.reload();
		}
	}, [updateServiceWorker]);

	useDebounceEffect(
		() => {
			if (needRefresh && idle) {
				update();
			}
		},
		[idle, needRefresh, update],
		{
			wait: 10_000,
		}
	);

	return (
		<Dialog opened={needRefresh && idle}>
			<Text size="xs">Automatically updating...</Text>
		</Dialog>
	);
}

export default ReloadPrompt;
